import combineReducers from "../../../utilities/combine-reducers";
import createReducer from '../../../utilities/create-reducer';
import * as actions from './actions';
import { OrderBuilderStatus, PresetStatus, CartStatus, ConfigurationGroupStatus, CustomOptionsStatus, CheckboxSettingsStatus, ItemCommentsStatus, ParentCodesStatus, DiscountSelectionSectionSettingsStatus, PromotionsStatus } from './constants';

const orderBuilderStatus = createReducer({
  [actions.SET_ORDER_BUILDER_STATUS]: (state, { payload }) => payload
}, OrderBuilderStatus.IDLE);

const orderBuilderData = createReducer({
  [actions.LOAD_ORDER_BUILDER_DATA]: () => null,
  [actions.SET_ORDER_BUILDER_DATA]: (state, { payload }) => payload
}, OrderBuilderStatus.IDLE);

const presetStatus = createReducer({
  [actions.SET_PRESET_STATUS]: (state, { payload }) => payload
}, PresetStatus.IDLE);

const presetData = createReducer({
  [actions.SET_PRESET_DATA]: (state, { payload }) => payload
}, PresetStatus.IDLE);

const itemCommentsStatus = createReducer({
  [actions.SET_ITEM_COMMENTS_STATUS]: (state, { payload }) => payload
}, ItemCommentsStatus.IDLE);

const itemCommentsData = createReducer({
  [actions.SET_ITEM_COMMENTS_DATA]: (state, { payload }) => payload
}, ItemCommentsStatus.IDLE);

const checkboxSettingsStatus = createReducer({
  [actions.SET_CHECKBOX_SETTINGS_STATUS]: (state, { payload }) => payload
}, CheckboxSettingsStatus.IDLE);

const checkboxSettingsData = createReducer({
  [actions.SET_CHECKBOX_SETTINGS_DATA]: (state, { payload }) => payload
}, CheckboxSettingsStatus.IDLE);

const discountSelectionSectionSettingsStatus = createReducer({
  [actions.SET_DISCOUNT_SELECTION_SECTION_STATUS]: (state, { payload }) => payload
}, DiscountSelectionSectionSettingsStatus.IDLE);

const discountSelectionSectionSettingsData = createReducer({
  [actions.SET_DISCOUNT_SELECTION_SECTION_DATA]: (state, { payload }) => payload
}, DiscountSelectionSectionSettingsStatus.IDLE);

const promotionsStatus = createReducer({
  [actions.SET_PROMOTIONS_STATUS]: (state, { payload }) => payload
}, PromotionsStatus.IDLE);

const promotionsData = createReducer({
  [actions.SET_PROMOTIONS_DATA]: (state, { payload }) => payload
}, []);

const configurationGroupStatus = createReducer({
  [actions.SET_CONFIGURATION_GROUP_STATUS]: (state, { payload }) => payload
}, ConfigurationGroupStatus.IDLE);

const configurationGroupData = createReducer({
  [actions.SET_CONFIGURATION_GROUP_DATA]: (state, { payload }) => payload
}, ConfigurationGroupStatus.IDLE);

const configurationGroupLeft = createReducer({
  [actions.LOAD_ORDER_BUILDER_DATA]: () => null,
  [actions.SET_CONFIGURATION_GROUP_LEFT]: (state, { payload }) => payload
}, ConfigurationGroupStatus.IDLE);

const configurationGroupRight = createReducer({
  [actions.LOAD_ORDER_BUILDER_DATA]: () => null,
  [actions.SET_CONFIGURATION_GROUP_RIGHT]: (state, { payload }) => payload
}, ConfigurationGroupStatus.IDLE);

const customOptionsGroupsStatus = createReducer({
  [actions.SET_CUSTOM_OPTIONS_GROUP_STATUS]: (state, { payload }) => payload
}, CustomOptionsStatus.IDLE); // Updated this line

const customOptionsGroupsData = createReducer({
  [actions.SET_CUSTOM_OPTIONS_GROUP_DATA]: (state, { payload }) => payload
}, CustomOptionsStatus.IDLE);

const customOptionsGroupLeft = createReducer({
  [actions.LOAD_ORDER_BUILDER_DATA]: () => null,
  [actions.SET_CUSTOM_OPTIONS_GROUP_LEFT]: (state, { payload }) => payload
}, CustomOptionsStatus.IDLE);

const customOptionsGroupRight = createReducer({
  [actions.LOAD_ORDER_BUILDER_DATA]: () => null,
  [actions.SET_CUSTOM_OPTIONS_GROUP_RIGHT]: (state, { payload }) => payload
}, CustomOptionsStatus.IDLE);

const cartStatus = createReducer({
  [actions.SET_CART_STATUS]: (state, { payload }) => payload
}, CartStatus.IDLE);

const cartData = createReducer({
  [actions.SET_CART_DATA]: (state, { payload }) => payload
}, CartStatus.IDLE);

const parentCodesStatus = createReducer({
  [actions.SET_PARENT_CODES_STATUS]: (state, { payload }) => payload
}, ParentCodesStatus.IDLE);

const parentCodesData = createReducer({
  [actions.SET_PARENT_CODES_DATA]: (state, { payload }) => payload
}, ParentCodesStatus.IDLE);

export default combineReducers({
  orderBuilderStatus,
  orderBuilderData,
  itemCommentsStatus,
  itemCommentsData,
  checkboxSettingsStatus,
  checkboxSettingsData,
  discountSelectionSectionSettingsStatus,
  discountSelectionSectionSettingsData,
  promotionsStatus,
  promotionsData,
  cartStatus,
  cartData,
  configurationGroupStatus,
  configurationGroupData,
  configurationGroupLeft,
  configurationGroupRight,
  customOptionsGroupsStatus,
  customOptionsGroupsData,
  customOptionsGroupLeft,
  customOptionsGroupRight,
  parentCodesStatus,
  parentCodesData,
  presetData,
  presetStatus,
});
